import { z } from 'zod';
import { numberParameter } from './shared.js';

// SASF: API 2026 Update 0.1 p90; Macro-PLUS p95.
const surfaceCurvaturesSettings = z.strictObject({
  surface: z.number().int().nonnegative().max(2147483647).describe('Native surface index; 0 is the object. CODE V validates existence.'),
  zoom: z.number().int().nonnegative().max(2147483647).default(1).describe('Native zoom input, passed unchanged. Native build 43679075 accepts 0 and 99; the result identifies the input without claiming an independently resolved position. The default 1 is the first position, which every lens has; a lens without ZOO has only that one (PromptingGuide p74; ZoomSystems.17.02, ZOO range 1 to 99).'),
  points: z.array(z.strictObject({ x: z.number(), y: z.number() })).min(1)
    .describe('Explicit X/Y coordinates in system length units, retained in input order. No sampling grid is generated.'),
});
export default {
  label: 'Surface Curvatures', group: 'system',
  description: 'Principal curvatures of a surface and their orientation, at the points you enter.',
  settingsSchema: surfaceCurvaturesSettings,
  parameters: [
    numberParameter('surface', 'Surface', { integer: true, choices: 'surface', prominent: true }),
    numberParameter('zoom', 'Zoom', { integer: true, hidden: true }),
    { key: 'points', label: 'Surface coordinates', kind: 'rows', prominent: true, columns: [
      numberParameter('x', 'X', { unit: 'system length' }),
      numberParameter('y', 'Y', { unit: 'system length' }),
    ] },
  ],
  coverage: 'One surface per run. Minimum and maximum principal curvatures are in reciprocal lens units. The orientation of the maximum curvature is in degrees from the Y axis of the plane tangent to the surface at that point (0 when the maximum curvature lies along it); on a sloped surface this can differ from the azimuth in the XY plane. If CODE V reports an error or warning, no values are shown.',
} as const;
